import { useState } from 'react'

import { RequestProfileTabInternalTasksContext } from '../RequestProfileTabInternalTasks.context'
import { useRequestProfileTabInternalTasksData } from '../RequestProfileTabInternalTasks.hooks'

function RequestProfileTabInternalTasksContextProvider({
  canEdit,
  canEditDoneChecklistItem,
  children,
  requestId,
  onLoadCounters,
}) {
  const [modal, setModal] = useState(null)

  const internalTasksData = useRequestProfileTabInternalTasksData({
    requestId,
    onLoadCounters,
  })

  function handleCloseModal() {
    setModal(null)
  }

  const value = {
    ...internalTasksData,
    canEdit,
    canEditDoneChecklistItem,
    requestId,
    setModal,
    onCloseModal: handleCloseModal,
  }

  return (
    <RequestProfileTabInternalTasksContext.Provider value={value}>
      {children}
      {modal}
    </RequestProfileTabInternalTasksContext.Provider>
  )
}

export default RequestProfileTabInternalTasksContextProvider
